module.exports = __webpack_public_path__ + "media/images/project/reward/r10000-89a33a693452ee72b81d4c196fd07ef9.jpg";